import getLocalizedTexts from '../localization'
import {
    // Constants
    SHOW_SELECTOR,
    HIDE_SELECTOR,
    TOGGLE_SELECTOR,

    // Actions
    setManageProfilesText,

    // Selectors
    isOpen,
    getUserId,
} from '../data'
import { actions, constants as c } from '../imports'

const log = (store, text) => {
    store.dispatch(actions.log(text))
}

const ProfileSelectorMiddleware = store => next => (action) => {
    switch (action.type) {
        // Locale has changed, get the localized text
        case c.LOCALE_CHANGED: {
            const result = next(action)
            const text = getLocalizedTexts(action.payload)
            store.dispatch(setManageProfilesText(text.manage_profiles))
            return result
        }

        case SHOW_SELECTOR: {
            const result = next(action)
            const { userId } = action.payload
            log(store, `Profile selector opened for ${userId}`)
            return result
        }

        case HIDE_SELECTOR: {
            const userId = getUserId(store.getState())
            const result = next(action)
            log(store, `Profile selector for ${userId} closed`)
            return result
        }

        case TOGGLE_SELECTOR: {
            const result = next(action)
            const { userId } = action.payload
            if (isOpen(store.getState())) {
                log(store, `Profile selector opened for ${userId}`)
            } else {
                log(store, `Profile selector for ${userId} closed`)
            }
            return result
        }

        default:
            return next(action)
    }
}

export default ProfileSelectorMiddleware



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/middleware/index.js